import React, { useState } from "react";
import styled from "styled-components";

const ProductImages = ({ images = [{ url: "" }] }) => {
  // console.log(images[0].url);
  //image =[] ye is liye kyuki yaha par starting me image undefined h aur image undefined h is iye image array me url bhi undefined hoga is liye apn ne default value empty dediye

  const [mainImage, setMainImage] = useState(images[0]);

  return (
    <Wrapper>
      <img src={mainImage.url} alt="main Image" className="main" />
      <div className="gallery">
        {images.map((image, index) => {
          return (
            <img
              src={image.url}
              alt="image"
              key={index}
              onClick={() => {
                setMainImage(images[index]);
              }}
              className={`${image.url === mainImage.url ? "active" : ""}`}
            />
          );
        })}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .main {
    height: 600px;
  }
  img {
    width: 100%;
    display: block;
    border-radius: var(--radius);
    object-fit: cover;
  }
  .gallery {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: 1rem;
    img {
      height: 100px;
      cursor: pointer;
    }
  }
  .active {
    border: 2px solid var(--clr-primary-5);
  }
  @media (max-width: 576px) {
    .main {
      height: 300px;
    }
    .gallery {
      img {
        height: 50px;
      }
    }
  }
  @media (min-width: 992px) {
    .main {
      height: 500px;
    }
    .gallery {
      img {
        height: 75px;
      }
    }
  }
`;
export default ProductImages;
